export default __webpack_public_path__ + "static/Pancakeswap-color-17-f40afda6bead36c045c3a2a6153609ca.svg";